const leftArrows = document.querySelectorAll('.arrow.left');
const rightArrows = document.querySelectorAll('.arrow.right');
const slider = document.querySelector('.testimonial-slider-slider');
const columns = document.querySelectorAll('.testimonial-slider-colonna');
const desktopArrowContainer = document.getElementById('desktop-arrows');
const mobileArrowContainer = document.getElementById('mobile-arrows');
let currentIndex = 0;

let startX = 0, startY = 0, currentX = 0, currentY = 0;
let isSwiping = false, isScrollingVertically = false;
let touchStartTime = 0;

function isMobile() {
    return window.innerWidth <= 780;
}

function updateSliderHeight() {
    const activeColumn = document.querySelector('.testimonial-slider-colonna.active');
    const sliderWrapper = document.querySelector('.testimonial-slider-slider-wrapper');
    if (activeColumn) {
        const columnHeight = activeColumn.getBoundingClientRect().height + 50 + 1;
        sliderWrapper.style.minHeight = `${columnHeight}px`;
    }
}

function updateActiveColumn() {
    columns.forEach((column, index) => {
        column.classList.toggle('active', index === currentIndex);
        column.classList.toggle('inactive', index !== currentIndex);
    });
    //updateSliderHeight();
}

function moveSlider() {
    if (isMobile()) {
        const sliderWrapper = document.querySelector('.testimonial-slider-slider-wrapper');
        const wrapperWidth = sliderWrapper.offsetWidth;
        const columnWidth = wrapperWidth * 0.85;
        const gap = 12;
        const centerOffset = (wrapperWidth - columnWidth) / 2;
        const slidePosition = currentIndex * (columnWidth + gap);
        const translateX = -slidePosition + centerOffset;
        slider.style.transform = `translateX(${translateX}px)`;
        updateActiveColumn();
    } else {
        const columnWidth = columns[0].offsetWidth;
        const gap = 20;
        const translateX = -(currentIndex * (columnWidth + gap));
        slider.style.transform = `translateX(${translateX}px)`;
    }
    updateArrowsState();
}

function handleResize() {
    if (isMobile()) {
        columns.forEach(column => {
            column.style.minWidth = '85%';
            column.style.width = '85%';
            column.style.flex = '0 0 85%';
        });
    } else {
        columns.forEach(column => {
            column.style.minWidth = '0';
            column.style.flex = '0 0 calc((100% - 40px) / 3)';
        });
    }
    moveSlider();
    updateArrowsVisibility();
    //updateSliderHeight();
}

function updateArrowsVisibility() {
    if (isMobile()) {
        mobileArrowContainer.classList.toggle('show', columns.length >= 1);
        desktopArrowContainer.classList.remove('show');
    } else {
        desktopArrowContainer.classList.toggle('show', columns.length > 3);
        mobileArrowContainer.classList.remove('show');
    }
}

function updateArrowsState() {
    if (isMobile()) {
        leftArrows.forEach(arrow => arrow.disabled = currentIndex === 0);
        rightArrows.forEach(arrow => arrow.disabled = currentIndex === columns.length - 1);
    } else {
        leftArrows.forEach(arrow => arrow.disabled = currentIndex === 0);
        rightArrows.forEach(arrow => arrow.disabled = currentIndex >= columns.length - 3);
    }
}

function handleTouchStart(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].pageY;
    currentX = startX;
    currentY = startY;
    touchStartTime = Date.now();
    isSwiping = true;
    isScrollingVertically = false;
    slider.style.transition = "none";
}

function handleTouchMove(e) {
    if (!isSwiping) return;

    currentX = e.touches[0].clientX;
    currentY = e.touches[0].pageY;

    const deltaX = Math.abs(currentX - startX);
    const deltaY = Math.abs(currentY - startY);

    if (!isScrollingVertically && deltaY > deltaX && deltaY > 10) {
        isScrollingVertically = true;
        isSwiping = false;
        slider.style.transition = "transform 0.3s ease-in-out";
        moveSlider();
        return;
    }

    if (!isScrollingVertically && deltaX > deltaY) {
        e.preventDefault();
        const columnWidth = columns[0].offsetWidth;
        const gap = isMobile() ? 12 : 20;
        const wrapperWidth = slider.parentElement.offsetWidth;
        const columnTotalWidth = columnWidth + gap;
        let translateX;
        if (isMobile()) {
            const centerOffset = (wrapperWidth - columnWidth) / 2;
            translateX = -(currentIndex * columnTotalWidth) + (currentX - startX) + centerOffset;
        } else {
            translateX = -(currentIndex * columnTotalWidth) + (currentX - startX);
        }
        slider.style.transform = `translateX(${translateX}px)`;
    }
}

function handleTouchEnd() {
    if (!isSwiping || isScrollingVertically) return;

    const touchEndTime = Date.now();
    const touchDuration = touchEndTime - touchStartTime;
    const deltaX = currentX - startX;
    const swipeVelocity = Math.abs(deltaX) / touchDuration;

    slider.style.transition = "transform 0.3s ease-in-out";

    const minSwipeDistance = 50;
    const minSwipeVelocity = 0.5;

    if (Math.abs(deltaX) > minSwipeDistance || swipeVelocity > minSwipeVelocity) {
        if (deltaX > 0 && currentIndex > 0) currentIndex--;
        else if (deltaX < 0 && currentIndex < columns.length - 1) currentIndex++;
    }

    moveSlider();
    isSwiping = false;
    isScrollingVertically = false;
}

leftArrows.forEach(arrow => {
    arrow.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            moveSlider();
        }
    });
});

rightArrows.forEach(arrow => {
    arrow.addEventListener('click', () => {
        if (currentIndex < columns.length - 1) {
            currentIndex++;
            moveSlider();
        }
    });
});

slider.addEventListener('touchstart', handleTouchStart, { passive: false });
slider.addEventListener('touchmove', handleTouchMove, { passive: false });
slider.addEventListener('touchend', handleTouchEnd);
slider.addEventListener('touchcancel', handleTouchEnd);

document.querySelector('.testimonial-slider-slider').style.cssText = `
    @media screen and (max-width: 780px) {
        padding: 0 !important;
        gap: 12px;
        width: auto;
        min-width: 100%;
        display: flex;
        transition: transform 0.3s ease-in-out;
    }
`;

updateArrowsVisibility();
updateArrowsState();
updateActiveColumn();
//updateSliderHeight();
handleResize();

window.addEventListener('resize', () => {
    handleResize();
    updateArrowsVisibility();
    moveSlider();
    //updateSliderHeight();
});
